import React, { useEffect, useState } from "react";

import Loading from "../common/loading";
import Button from "../common/button";
import ViewModeAlert from "../viewModeAlert";

import authService from "../../services/authService";
import assignmentsService from "../../services/assignmentsService";

import AIRPage from "./base-page";
import AIRQuiz from "./quiz";
import AIRPagewithPopups from "./page-with-popups";
import AIRRiskQuiz from "./risk-quiz";
import "./air.css";

const AIRCourseMain = (props) => {
  const queryID = props.match.params.pageId ? props.match.params.pageId : 1;
  console.log("AIRCourseMain props:", queryID);
  const questionID = props.match.params.id ? Number(props.match.params.id) : 0;
  const pathSegments = props.match.path.split("/");
  const segmentBeforeParam =
    pathSegments[pathSegments.length - 1].split("=")[0]; // "page"
  const { history } = props;
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [course, setCourse] = useState();
  const [endPage, setEndPage] = useState();
  const [contentType, setContentType] = useState(segmentBeforeParam);
  const [quizItems, setQuizItems] = useState([]);
  const [currentPageNo, setCurrentPageNo] = useState(queryID);
  const [currentPage, setCurrentPage] = useState();
  const [showViewModeMessage, setShowViewModeMessage] = useState(false);
  // const [useQuizNav, setUseQuizNav] = useState(false);

  let user = authService.getCurrentUser();
  const toggleViewModeMessage = () => {
    setShowViewModeMessage(!showViewModeMessage);
  };
  const onRegister = () => {
    props.history.push({
      pathname: "/auth",
      state: { prevPath: props.location.pathname },
    });
    setShowViewModeMessage(false);
  };

  useEffect(() => {
    if (!user && Number(queryID) !== 1) {
      // setLoading(false);
      setShowViewModeMessage(true);
    } else initAIRCourse();
  }, []);

  useEffect(() => {
    if (course) {
      setLoading(false);
      if (Number(queryID)) {
        setCurrentPage(course[Number(queryID) - 1]);
        // console.log("Setting to page:", course[Number(queryID) - 1]);
      }

      //
      if (props.match.path.includes("question") && course[queryID - 1].quiz) {
        // console.log("props path:", props.match.path.includes("question"));
        setContentType("questions");
      }
    }
  }, [course]);

  useEffect(() => {
    if (endPage && queryID === "end") {
      console.log("Setting to end page:", endPage);
      setCurrentPage(endPage);
      setContentType("page");

      console.log("current:", currentPageNo);
      setLoading(false);
    }
  }, [endPage]);

  const initAIRCourse = async () => {
    // setCurrentPage(initialPage);
    try {
      let airCourseRes = await assignmentsService.getCourses("air");
      if (airCourseRes.status !== 200) {
        console.log("server error!");
        setErrors((prev) => ({
          ...prev,
          network: airCourseRes.data.error,
        }));
        setLoading(false);
      } else {
        let filteredItems = Object.values(airCourseRes.data.course).filter(
          (item) => ["quiz", "quizend"].indexOf(item.id) === -1
        );
        let quizItem = Object.values(airCourseRes.data.course).find(
          (item) => item.id === "quiz"
        );
        let endItem = Object.values(airCourseRes.data.course).find(
          (item) => item.id === "quizend"
        );
        let quizItems = JSON.parse(quizItem.content);
        // console.log("Quiz items:", quizItems.allQuestions);
        setQuizItems(quizItems.allQuestions);
        setCourse(filteredItems);
        setEndPage(endItem);

        if (Number(queryID)) setCurrentPageNo(Number(queryID));
        else setCurrentPageNo(queryID);
      }
    } catch (err) {
      let error = err.message || "Es ist ein unerwarteter Fehler aufgetreten.";
      console.error("Error fetching AIR course data:", err);
      setErrors((prev) => ({
        ...prev,
        network: error,
      }));
      setLoading(false);
    }
  };

  const handleNext = () => {
    if (user) {
      console.log("handleNext:");

      if (contentType === "page") {
        if (currentPageNo === course.length) {
          const queryParams = new URLSearchParams(props.location.search);
          history.push({
            pathname: "/ethics/ai-regulations/quiz=1",
            search: queryParams.toString(),
          });
          //   setQuestionNo(1);
          setContentType("quiz");

          console.log("Switching to", contentType, "id", currentPageNo);
          return;
        } else if (currentPageNo === "end") {
          const queryParams = new URLSearchParams(props.location.search);
          history.push({
            pathname: "/ethics",
            search: queryParams.toString(),
          });
        } else {
          let nextPage = currentPageNo + 1;
          if (nextPage > course.length) {
            nextPage = course.length; // Prevent going beyond the last page
          }

          const queryParams = new URLSearchParams(props.location.search);
          history.push({
            pathname: `/ethics/ai-regulations/page=${nextPage}`,
            search: queryParams.toString(),
          });
          setCurrentPage(nextPage);
        }
      }
    } else setShowViewModeMessage(true);
  };

  const handlePrevious = () => {
    if (currentPageNo === "end") {
      const queryParams = new URLSearchParams(props.location.search);
      history.push({
        pathname: `/ethics/ai-regulations/quiz=7`,
        search: queryParams.toString(),
      });
      return;
    }

    let prevPage = currentPageNo - 1;
    if (prevPage < 1) {
      prevPage = 1; // Prevent going beyond the first page
    }

    const queryParams = new URLSearchParams(props.location.search);
    history.push({
      pathname: `/ethics/ai-regulations/page=${prevPage}`,
      search: queryParams.toString(),
    });
    setCurrentPage(prevPage);
  };

  function PageSelector({ page }) {
    // Determine which page component to render based on page properties
    if (!page) return null;

    if (page.popup) return <AIRPagewithPopups description={page} />;
    else return <AIRPage page={page} />;
  }

  return (
    <>
      <section className="content">
        <div className="container-limit my-limit">
          {loading ? (
            <Loading />
          ) : (
            <>
              {errors.network && (
                <div className="alert alert-danger" role="alert">
                  {errors.network}
                </div>
              )}
              <div className="intro-section">
                <div className="air-wrapper">
                  {contentType === "page" && currentPage && (
                    <PageSelector page={currentPage} />
                  )}
                  {contentType === "questions" && currentPage.quiz && (
                    <AIRRiskQuiz description={currentPage.quiz} props={props} />
                  )}
                  {contentType === "quiz" && quizItems && (
                    <AIRQuiz
                      description={quizItems}
                      noOfQuestions={quizItems.length}
                      props={props}
                    />
                  )}
                </div>

                <div className="nav-button-wrapper">
                  {contentType === "page" && (
                    <>
                      {currentPageNo !== 1 && (
                        <Button
                          href="#"
                          onClick={handlePrevious}
                          label="Zurück"
                        />
                      )}
                      {currentPageNo <= course.length && (
                        <Button
                          href="#"
                          onClick={handleNext}
                          label="Weiter"
                          className="weiterBtn"
                        />
                      )}
                      {currentPageNo === "end" && (
                        <Button
                          href="#"
                          onClick={handleNext}
                          label="Weiter"
                          className="weiterBtn"
                        />
                      )}
                    </>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </section>
      {showViewModeMessage && (
        <ViewModeAlert
          onRegister={onRegister}
          onCancel={toggleViewModeMessage}
        />
      )}
    </>
  );
};

export default AIRCourseMain;
